import { Injectable } from '@angular/core';
import { PortalRegion } from '@obo-portal/models/portal.models';
import { HttpClient } from '@angular/common/http';
import { RegionService } from '@obo-main/services/region/region.service';
import { map } from 'rxjs/operators';
import { NominatimResponse } from '@obo-main/services/location/location.models';
import { Observable } from 'rxjs';

@Injectable()
export class LocationService {
    public static readonly nominatimUrl: string = 'https://nominatim.openstreetmap.org';

    constructor(private http: HttpClient, private regionService: RegionService) {}

    public getCoordinates(): Promise<GeolocationPosition> {
        return new Promise<GeolocationPosition>((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
                timeout: 1000,
                enableHighAccuracy: false
            });
        });
    }

    public getPortalRegionByGeoPosition(position: GeolocationPosition): Observable<PortalRegion> {
        return this.http
            .get<NominatimResponse>(LocationService.nominatimUrl + '/reverse', {
                headers: {
                    'Accept-Language': 'en-US'
                },
                params: {
                    lat: position.coords.latitude.toString(),
                    lon: position.coords.longitude.toString(),
                    format: 'json',
                    zoom: 3
                }
            })
            .pipe(
                map((response: NominatimResponse) => {
                    return this.regionService.portalRegions.find((region) => {
                        return region.name === response.address.country_code.toUpperCase();
                    });
                })
            );
    }
}
